<template>
  <div>
    <div v-if="modalData !== null && modalData !== undefined" v-for="data in modalData">
      <div class="custom-modal modal-backdrop notify-user-modal">
        <div class="modal-user-noty user-noty-modal">
          <button class="buy-number-modal-close-btn block-number-modal-close-btn user-noty-close-btn"
                  @click="closeNotification(data.id, $event)"></button>
          <div class="buy-number-title buy-number-title-gray"><p v-if="data.title">{{ data.title }}</p> {{ data.message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'simpleModal',
  props: ['modalData'],
  data() {
    return {}
  },
  methods: {
    closeNotification(id, event) {
      const modal = event.currentTarget.closest('.notify-user-modal');
      if (modal) {
        modal.style.display = 'none';
      }

      this.$emit('close', id);
    }
  }
}
</script>

<style scoped lang="scss">
.buy-number-title {
  p {
    margin-bottom: 10px;
  }
}

</style>
